import React from "react";

const BranchLocationMap = () => (
  <iframe
    title="Branch location map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.5606931613706!2d9.1903034158094!3d45.478652779101175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6ca48e55555%3A0x49c79c65a215593b!2sSevendata!5e0!3m2!1sen!2s!4v1623680804289!5m2!1sen!2s"
    width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"/>
);

export default BranchLocationMap;